module.exports = __webpack_public_path__ + "img/logo_icon.0ccfb36d.png";